export function getContentTarget(event, fileType, _isPwa) {
    if (fileType && (fileType === 'Fluid' || fileType === 'Forms')) {
        return '_self';
    }
    else if (event && (event['ctrlKey'] || event['button'] === 1)) {
        // handling click with ctrl key and middle mouse button.
        return '_blank';
    }
    else {
        return '_blank';
    }
}
//# sourceMappingURL=getContentTarget.js.map